import React, { useState, useEffect } from 'react';
import Axios from "axios";
import './../../../../assets/css/purchase/form.css';

// React DateTime
import Datetime from 'react-datetime';
import moment from 'moment';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import ItemWhTable from '../../../components/Content/ItemWhTable';
import FormAction from '../../../components/Actions/FormAction';

// Model
import { wtDocMasterModel } from '../../../../model/Warehouse/WTDocMasterModel';
import { wtDocDetailModel } from '../../../../model/Warehouse/WTDocDetailModel';

import {
  getData,
  getDataWithComp,
  formatCurrency,
  getAlert,
  deleteData,
  randomDelay,
  parseCurrency,
  getSpRunNumber
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  setCreateDateTime,
  formatDate
} from "../../../../utils/DateUtils";

import { manageWhItemData } from '../../../../utils/WarehouseUtils';
import EmployeeModal from '../../../components/Modal/EmployeeModal';
import DatePicker from '../../../components/DatePicker';

const Form = ({ callInitialize, mode, setMode, name, wtDocNo }) => {
  const [formMasterList, setFormMasterList] = useState(wtDocMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [empDataList, setEmpDataList] = useState([]);

  // การเลือกคลังจากหน้าจอ
  const [selectedWarehouseFrom, setSelectedWarehouseFrom] = useState(null);

  // ใช้สำหรับตั้งตัวแปรรับข้อมูลแผนกผู้เบิก
  const [deptName, setDeptName] = useState("");

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const whDataList = await getDataWithComp('Tb_Set_WH', `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`);
    if (whDataList && whDataList.length > 0) {
      setWhDataList(whDataList);
    }

    const empDataList = await getDataWithComp('View_Set_Employee', `AND Emp_Status = 'Y' ORDER BY Emp_Code ASC`);
    if (empDataList && empDataList.length > 0) {
      setEmpDataList(empDataList);
    }

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === 'U') {
      await getModelByNo(empDataList);
    }

    // โรงน้ำแข็ง ต้องการ Default คลัง "กล่องอุปกรณ์เครื่องมือช่าง"
    if (localStorage.getItem("company") === "2") {
      handleChangeWarehouse("63");
    }
  };

  const getModelByNo = async (empDataList) => {
    try {
      const fromDatabase = await getDataWithComp('WTDoc_H', `AND WTDoc_No = '${wtDocNo}'`);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewEmp = empDataList.find(
        (emp) => emp.Emp_Id === fromDatabase[0].WTDoc_Emp_Id
      );

      if (!fromViewEmp) {
        throw new Error("ไม่พบข้อมูลพนักงานช่าง");
      }

      // ฟังก์ชันดึงข้อมูล itemOnHand
      const getOnHand = async (whId, itemId) => {
        const itemOnHand = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(itemId)}`);
        return itemOnHand[0].Item_Onhand;
      };

      // ฟังก์ชันสร้างแถวใหม่
      const createNewRow = (index, itemSelected, itemOnHand) => {
        return {
          ...wtDocDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          wtDocId: itemSelected.WtDoc_Id || null,
          line: itemSelected.Line || null,
          itemId: itemSelected.Item_Id || null,
          itemCode: itemSelected.Item_Code || null,
          itemName: itemSelected.Item_Name || null,
          itemDesc: itemSelected.Item_Desc || "",
          itemOnHand: itemOnHand || null,
          itemQty: itemSelected.Item_Qty ? formatCurrency(itemSelected.Item_Qty) : null,
          itemIncrease: null,
          itemDecrease: itemSelected.Item_Qty || null,
          itemOrder: null,
          itemBalance: parseCurrency(itemOnHand) - parseCurrency(itemSelected.Item_Qty),
          itemUnit: itemSelected.Item_Unit || null,
          itemPriceUnit: itemSelected.Item_Price_Unit || null,
          itemDiscount: null,
          itemDisType: null,
          itemTotal: itemSelected.Item_Total || null,
          docType: itemSelected.Doc_Type || null,
          refDocId: itemSelected.Ref_DocID || null,
          refDocNo: itemSelected.Ref_DocNo || null,
          itemIsReturn: parseCurrency(itemSelected.Item_Is_Return) || 0,
          itemReturnDate: formatDate(itemSelected.Item_Return_Date) || null
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย WTDoc_Id
      const fromDetail = await getDataWithComp('API_1602_WTDOC_D', `AND WTDoc_Id = ${fromDatabase[0].WTDoc_Id} AND Item_Is_Return <> 1 ORDER BY Line ASC`);

      if (fromDetail.length > 0) {
        // สร้าง Promises สำหรับ itemOnHand
        const itemOnHandPromises = fromDetail.map(item => getOnHand(fromDatabase[0].F_WT_Id, item.Item_Id));

        // รอ Promises
        const itemOnHandResults = await Promise.all(itemOnHandPromises);

        // สร้าง newFormDetails โดยใช้ itemOnHandResults
        const newFormDetails = fromDetail.map((item, index) => createNewRow(formDetailList.length + index, item, itemOnHandResults[index]));

        await handleChangeWarehouse(String(fromDatabase[0].F_WT_Id), 'FROM');

        setFormDetailList(newFormDetails);

        const data = fromDatabase[0];

        setFormMasterList({
          wtDocId: data.WTDoc_Id,
          wtDocNo: data.WTDoc_No,
          wtDocType: data.WTDoc_Type,
          wtDocEmpId: data.WTDoc_Emp_Id,
          wtDocEmpCode: fromViewEmp.Emp_Code,
          wtDocEmpName: fromViewEmp.Emp_Name,
          wtDocDate: data.WTDoc_Date,
          wtDocTransDate: data.WTDoc_TransDate,
          wtDocCreatedDate: setCreateDateTime(data.WTDoc_CreatedDate),
          wtDocCreatedBy: data.WTDoc_CreatedBy,
          wtDocStatus: data.WTDoc_Status,
          wtDocSeq: data.WTDoc_SEQ,
          wtDocRemark: data.WTDoc_Remark,
          wtDocCompId: data.Comp_Id,
          wtDocShowFront: data.WTDoc_ShowFront,
          refDocId: data.Ref_DocID,
          refDoc: null,
          refDocDate: null
        });

      } else {
        getAlert('FAILED', `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase[0].WTDoc_No} กรุณาตรวจสอบและลองอีกครั้ง`);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format('YYYY-MM-DD') : null,
    }));
  };

  const handleChangeWarehouse = async (value) => {
    // เคลียค่าตอนกดย้ายคลัง
    if (mode === 'I') {
      setFormDetailList([]);
    }

    // ดึงข้อมูลจาก Tb_Set_Item
    const itemDataList = await getDataWithComp('Tb_Set_Item', `AND Item_Group IN (${localStorage.getItem("company") === "1" ? '13,16' : '3,4,21'}) AND Item_Status = 'Y' ORDER BY Item_Code ASC`);
    if (itemDataList && itemDataList.length > 0) {
      setItemDataList(itemDataList);
    }

    // ดึงข้อมูลจาก API_1101_WH_ITEM_ONHAND
    const itemOnHandList = await getDataWithComp('API_1101_WH_ITEM_ONHAND', `AND WH_Id = ${parseCurrency(value)} ORDER BY Item_Code ASC`);

    if (itemOnHandList && itemOnHandList.length > 0 && itemDataList && itemDataList.length > 0) {
      // กรอง itemOnHandList โดยเช็ค Item_Id ที่มีใน itemDataList
      const filteredItemOnHandList = itemOnHandList.filter(itemOnHand =>
        itemDataList.some(itemData => parseCurrency(itemData.Item_Id) === parseCurrency(itemOnHand.Item_Id))
      );

      // รวม Item_Cost จาก itemDataList เข้าไปในรายการที่จะแสดง
      const mergedItemList = filteredItemOnHandList.map(itemOnHand => {
        const found = itemDataList.find(itemData => parseCurrency(itemData.Item_Id) === parseCurrency(itemOnHand.Item_Id));
        return {
          ...itemOnHand,
          Item_Cost: found?.Item_Cost || 0,
        };
      });

      setItemDataList(mergedItemList);
    }

    setSelectedWarehouseFrom(value);
  };

  const handleQuantityChange = (index, type, value, onHand) => {
    // ดักค่าเพื่อให้ส่งมาอย่างถูกต้อง (จริงๆแล้วแทบไม่ได้ใช้)
    if (type !== 'decrease') {
      getAlert("FAILED", "พบข้อผิดพลาดในการดำเนินการ กรุณารีเฟชรแล้วลองใหม่");
    }

    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    // หากผู้ใช้กรอกจุดทศนิยมอย่างเดียว (เช่น ".") ให้คงค่าเดิมไว้ก่อน
    if (value === ".") {
      const updatedList = [...formDetailList];
      updatedList[index].itemDecrease = value;
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    const updatedList = [...formDetailList];

    // ดักไม่ให้ปรับปรุงเกินกว่าสินค้าคงเหลือ เฉพาะตอนปรับลดสินค้า
    if (parseCurrency(value) > parseCurrency(onHand)) {
      getAlert("FAILED", "กรุณาระบุจำนวนไม่เกินคงเหลือ");
      updatedList[index].itemDecrease = null;
      updatedList[index].docType = "AO";
      updatedList[index].itemBalance = parseCurrency(onHand);
      setFormDetailList(updatedList);
      return;
    }

    updatedList[index].docType = "AO";
    updatedList[index].itemDecrease = value;
    updatedList[index].itemQty = parseCurrency(value);
    updatedList[index].itemBalance = parseCurrency(onHand) - parseCurrency(value);
    updatedList[index].itemTotal = formatCurrency(
      parseCurrency(updatedList[index].itemQty) * parseCurrency(updatedList[index].itemPriceUnit || 0)
    );

    setFormDetailList(updatedList);
  };

  const handleFocus = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = parseCurrency(updatedList[index].itemQty) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDecrease = formatCurrency(updatedList[index].itemQty);
    setFormDetailList(updatedList);
  };

  const handleRemarkChange = (index, value) => {
    const updatedList = [...formDetailList];
    updatedList[index].itemDesc = value;
    setFormDetailList(updatedList);
  };

  const getDepartmentForEmp = async (empId) => {
    try {
      const department = await getDataWithComp('View_Set_Employee', `AND Emp_Id = ${empId}`);
      if (department && department.length > 0) {
        setDeptName(department[0].Dept_Name);
      }
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET EMP
  const [showEmpModal, setShowEmpModal] = useState(false);
  const handleEmpShow = () => setShowEmpModal(true);
  const handleEmpClose = () => setShowEmpModal(false);
  const onRowSelectEmp = (empSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        wtDocEmpId: empSelected.Emp_Id,
        wtDocEmpCode: empSelected.Emp_Code,
        wtDocEmpName: empSelected.Emp_Name,
        arAdd1: null,
        arAdd2: null,
        arAdd3: null,
        arProvince: null,
        arZipcode: null,
        arTaxNo: null,
      });

      // ค้นหาแผนกผู้เบิก
      getDepartmentForEmp(empSelected.Emp_Id);

      handleEmpClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      // ใช้ Set เพื่อกรอง Item_Id ที่ซ้ำกัน
      const uniqueItems = Array.from(
        new Set(itemsSelected.map(item => item.Item_Id))
      ).map(id => {
        return itemsSelected.find(item => item.Item_Id === id);
      });

      // อัปเดตรายการโดยคงค่าของสินค้าที่เคยมีอยู่
      const updatedFormDetailList = uniqueItems.map((itemSelected) => {
        // ค้นหาว่ามีสินค้าอยู่ใน formDetailList เดิมหรือไม่
        const existingItem = formDetailList.find(item => item.itemId === itemSelected.Item_Id);

        return {
          line: existingItem?.line || null,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: existingItem ? formatCurrency(existingItem.itemQty || 0) : formatCurrency(0),
          itemDecrease: existingItem ? formatCurrency(existingItem.itemDecrease || 0) : formatCurrency(0),
          itemUnit: existingItem ? existingItem.itemUnit : itemSelected.Item_Unit_ST,
          itemPriceUnit: existingItem ? existingItem.itemPriceUnit : formatCurrency(itemSelected.Item_Cost || 0),
          itemOnHand: existingItem ? existingItem.itemOnHand : formatCurrency(itemSelected.Item_Onhand || 0),
          itemBalance: existingItem ? existingItem.itemBalance : itemSelected.Item_Onhand || 0,
          itemTotal: existingItem
            ? existingItem.itemTotal
            : formatCurrency(
              parseCurrency(existingItem ? existingItem.itemQty || 0 : 0) * parseCurrency(itemSelected.Item_Cost || 0)
            ),
          docType: "AO",
          itemIsReturn: 0,
          itemReturnDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
          itemDesc: existingItem ? existingItem.itemDesc : ""
        };
      });
      setFormDetailList(updatedFormDetailList);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };

  const handleSubmit = async () => {
    try {
      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const newMaxTe = await getSpRunNumber("TE");
      if (!newMaxTe) {
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }

      if (formMasterList.wtDocEmpId === null) {
        getAlert("FAILED", "กรุณาเลือกไปพนักงานช่าง");
        return;
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะยืม");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนยืมของลังน้ำแข็ง : ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wt_doc_no: newMaxTe,
        wt_doc_type: parseCurrency("6", 10),
        wt_doc_emp_id: parseCurrency(formMasterList.wtDocEmpId, 10),
        wt_doc_date: formMasterList.wtDocDate,
        wt_doc_trans_date: formMasterList.wtDocTransDate,
        wt_doc_created_date: formatThaiDateUiToDate(formMasterList.wtDocCreatedDate),
        wt_doc_created_by: formMasterList.wtDocCreatedBy,
        wt_doc_status: parseCurrency("1", 10),
        wt_doc_seq: formatDateTime(new Date()),
        wt_doc_remark: formMasterList.wtDocRemark,
        comp_id: formMasterList.wtDocCompId,
        wt_doc_show_front: null,
        ref_doc_id: formMasterList.refDocId,
        f_wt_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wt_id: parseCurrency(formMasterList.wtDocEmpId, 10),
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wt-doc-h`, formMasterData, {
        headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      });

      if (response.data.status === 'OK') {
        const getWtDocIdResponse = await Axios.post(`${process.env.REACT_APP_API_URL}/api/get-by-wt-doc-no`, {
          table: 'WTDoc_H',
          wt_doc_no: newMaxTe,
          comp_id: window.localStorage.getItem('company')
        }, {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
        });

        if (getWtDocIdResponse && getWtDocIdResponse.data.length > 0) {
          const wtDocId = parseCurrency(getWtDocIdResponse.data[0].WTDoc_Id, 10);
          let line = 1;

          for (const item of formDetailList) {
            const formDetailData = {
              wt_doc_id: wtDocId,
              line: line,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_total: parseCurrency(item.itemQty) * parseCurrency(item.itemPriceUnit),
              doc_type: item.docType,
              ref_doc_id: item.refDocId,
              item_is_return: item.itemIsReturn,
              item_return_date: item.itemReturnDate,
              item_desc: item.itemDesc || null
            };
            line++;

            // ย้ายออก
            await manageWhItemData(
              item.itemId, // Item ไอดีของสิ่งนั้นๆ
              item.itemCode, // Item โค้ดของสิ่งนั้นๆ
              item.itemName, // ชื่อ Item นั้นๆ
              selectedWarehouseFrom, // WarehouseID ของไอเทม
              "AO", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
              wtDocId, // ไอดีเอกสาร
              newMaxTe, // เลขเอกสาร
              newMaxTe, // เลขเอกสารอ้างอิง
              formMasterList.wtDocRemark // หมายเหตุ
            );

            // เรียก API สร้างเอกสาร
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wt-doc-d`, formDetailData, {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            });
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      if (selectedWarehouseFrom === null) {
        getAlert("FAILED", "กรุณาเลือกจากคลัง");
        return;
      }

      if (formMasterList.wtDocEmpId === null) {
        getAlert("FAILED", "กรุณาเลือกไปพนักงานช่าง");
        return;
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้าที่จะยืม");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          getAlert("FAILED", `กรุณากรอกจำนวนยืมของลังน้ำแข็ง : ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wt_doc_no: formMasterList.wtDocNo,
        wt_doc_type: formMasterList.wtDocType,
        wt_doc_emp_id: parseCurrency(formMasterList.wtDocEmpId, 10),
        wt_doc_date: formMasterList.wtDocDate,
        wt_doc_trans_date: formMasterList.wtDocTransDate,
        wt_doc_created_date: formatThaiDateUiToDate(formMasterList.wtDocCreatedDate),
        wt_doc_created_by: formMasterList.wtDocCreatedBy,
        wt_doc_status: formMasterList.wtDocStatus,
        wt_doc_seq: formMasterList.wtDocSeq,
        wt_doc_remark: formMasterList.wtDocRemark,
        comp_id: formMasterList.wtDocCompId,
        wt_doc_show_front: formMasterList.wtDocShowFront,
        ref_doc_id: formMasterList.refDocId,
        f_wt_id: selectedWarehouseFrom,
        f_zone_id: formMasterList.fZoneId,
        f_lt_id: formMasterList.fLtId,
        t_wt_id: parseCurrency(formMasterList.wtDocEmpId, 10),
        t_zone_id: formMasterList.fZoneId,
        t_lt_id: formMasterList.fLtId,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-wt-doc-h`, formMasterData, {
        headers: { key: process.env.REACT_APP_ANALYTICS_KEY }
      });

      if (response.data.status === 'OK') {

        const findOldEquip = await getData('API_1602_WTDOC_D', `WTDoc_Id = ${formMasterList.wtDocId}`);

        if (findOldEquip && findOldEquip.length > 0) {
          for (const equipData of findOldEquip) {
            // ย้ายเข้า
            await manageWhItemData(
              equipData.Item_Id, // Item ไอดีของสิ่งนั้นๆ
              equipData.Item_Code, // Item โค้ดของสิ่งนั้นๆ
              equipData.Item_Name, // ชื่อ Item นั้นๆ
              equipData.F_WT_Id, // WarehouseID ของไอเทม
              "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(equipData.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
              equipData.WTDoc_Id, // ไอดีเอกสาร
              formMasterList.wtDocNo, // เลขเอกสาร
              formMasterList.wtDocNo, // เลขเอกสารอ้างอิง
              `แก้ไขใบ : ${formMasterList.wtDocNo}` // หมายเหตุ
            );
          }
        }

        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData('WTDoc_D', `WHERE WTDoc_Id = ${formMasterList.wtDocId}`);

        const wtDocId = parseCurrency(formMasterList.wtDocId, 10);
        let line = 1;

        for (const item of formDetailList) {
          const formDetailData = {
            wt_doc_id: wtDocId,
            line: line,
            item_id: item.itemId,
            item_code: item.itemCode,
            item_name: item.itemName,
            item_qty: parseCurrency(item.itemQty),
            item_unit: item.itemUnit,
            item_price_unit: parseCurrency(item.itemPriceUnit),
            item_total: parseCurrency(item.itemQty) * parseCurrency(item.itemPriceUnit),
            doc_type: item.docType,
            ref_doc_id: item.refDocId,
            item_is_return: item.itemIsReturn,
            item_return_date: item.itemReturnDate,
            item_desc: item.itemDesc || null
          };
          line++;

          // ย้ายออก
          await manageWhItemData(
            item.itemId, // Item ไอดีของสิ่งนั้นๆ
            item.itemCode, // Item โค้ดของสิ่งนั้นๆ
            item.itemName, // ชื่อ Item นั้นๆ
            selectedWarehouseFrom, // WarehouseID ของไอเทม
            "AO", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
            formMasterList.wtDocId, // ไอดีเอกสาร
            formMasterList.wtDocNo, // เลขเอกสาร
            formMasterList.wtDocNo, // เลขเอกสารอ้างอิง
            formMasterList.wtDocRemark // หมายเหตุ
          );

          // เรียก API เพื่อสร้างเอกสารทีละรายการ
          await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-wt-doc-d`, formDetailData, {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          });
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        wt_doc_no: formMasterList.wtDocNo,
        wt_doc_status: parseCurrency("13", 10),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-wt-doc-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === 'OK') {
        const findOldEquip = await getData('API_1602_WTDOC_D', `WTDoc_Id = ${formMasterList.wtDocId}`);
        if (findOldEquip && findOldEquip.length > 0) {
          for (const equipData of findOldEquip) {
            // ย้ายเข้า
            await manageWhItemData(
              equipData.Item_Id, // Item ไอดีของสิ่งนั้นๆ
              equipData.Item_Code, // Item โค้ดของสิ่งนั้นๆ
              equipData.Item_Name, // ชื่อ Item นั้นๆ
              equipData.F_WT_Id, // WarehouseID ของไอเทม
              "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(equipData.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
              equipData.WTDoc_Id, // ไอดีเอกสาร
              formMasterList.wtDocNo, // เลขเอกสาร
              formMasterList.wtDocNo, // เลขเอกสารอ้างอิง
              `ยกเลิกใบ : ${formMasterList.wtDocNo}` // หมายเหตุ
            );
          }
        }
      }

      // callInitialize();
      // getAlert(response.data.status, response.data.message);
      window.location.reload();
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  return <>
    <Breadcrumbs page={wtDocNo} items={[
      { name: 'คลังสินค้า', url: '/Warehouse' },
      { name: name, url: '/technical-equip-form' },
      { name: mode === 'U' ? "เรียกดู" + name : "สร้าง" + name, url: '#' }
    ]} />
    <div className="body">
      <div class="container-fluid my-4">
        <div className="row mb-1">
          <div className="col-4">
            <DatePicker
              label="วันที่เอกสาร"
              name="wtDocDate"
              value={formMasterList.wtDocDate}
              onChange={(date) => handleChangeDateMaster(date, "wtDocDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>จากคลัง : </label>
              <select
                class="form-select"
                value={selectedWarehouseFrom}
                disabled={mode === 'U' ? true : false}
                onChange={(e) => handleChangeWarehouse(e.target.value)}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>สร้างโดย : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.wtDocCreatedBy}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <DatePicker
              label="วันที่จัดส่ง"
              name="wtDocTransDate"
              value={formMasterList.wtDocTransDate}
              onChange={(date) => handleChangeDateMaster(date, "wtDocTransDate")}
              disabled={formMasterList.refDocId !== null}
            />
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>ผู้ขอเบิก :</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.wtDocEmpCode || '')
                    + " " +
                    (formMasterList.wtDocEmpName || '')
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleEmpShow}
                  disabled={mode === 'U' ? true : false}>
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <EmployeeModal
                showEmpModal={showEmpModal}
                handleEmpClose={handleEmpClose}
                empDataList={empDataList}
                onRowSelectEmp={onRowSelectEmp}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label className="">วันที่สร้าง : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.wtDocCreatedDate}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="wtDocRemark"
                value={formMasterList.wtDocRemark || ''}
                onChange={handleChangeMaster}
                disabled={formMasterList.refDocId !== null} />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex">
              <label>แผนก : </label>
              <input
                type="text"
                className="form-control input-spacing"
                value={deptName || ''}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <div className="col-4">
            {/* <div className="d-flex">
              <label>วันที่เอกสารอ้างอิง : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ''}
                disabled={true}
              />
            </div> */}
          </div>
          <div className="col-4" />
        </div>
      </div>
      <hr />
    </div>
    <div className="container-fluid my-3">
      <div className="row">
        <div className="col-12">
          <ItemWhTable
            mode={mode}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            formDetailList={formDetailList}
            handleItemShow={handleItemShow}
            handleQuantityChange={handleQuantityChange}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            disabled={selectedWarehouseFrom === null}
            showRemarkColumn
            handleRemarkChange={handleRemarkChange}
          />
          <FormAction
            onSubmit={handleSubmit}
            onUpdate={handleUpdate}
            onCancel={handleCancel}
            mode={mode}
            setMode={setMode}
            disabled={formMasterList.refDocId !== null}
            footer={true}
          />
        </div>
      </div>
    </div>
  </>
};

export default Form;
